import { render, staticRenderFns } from "./miPerfil.vue?vue&type=template&id=4be3e922&scoped=true"
import script from "./miPerfil.vue?vue&type=script&lang=js"
export * from "./miPerfil.vue?vue&type=script&lang=js"
import style0 from "./miPerfil.vue?vue&type=style&index=0&id=4be3e922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be3e922",
  null
  
)

export default component.exports